// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const cistern = defineModel({
  id: "cistern",
  batchId: "future",
  name: "Cistern",
  tags: ["building","cistern","low-poly","age-of-mcp","future","water"],
  summary: "A covered tank storing water for people, crafts and firefighting.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.78, 0.82, 0.22, 14), color: "#9a958a", position: [0, 0.25, 0] },
      { geometry: new THREE.CylinderGeometry(0.83, 0.83, 0.07, 14), color: "#7c776c", position: [0, 0.34, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [-0.8, 0.275, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [0.8, 0.275, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [-0.8, 0.275, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [0.8, 0.275, 0.8] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.78, 0.82, 0.4, 14), color: "#9a958a", position: [0, 0.34, 0] },
      { geometry: new THREE.CylinderGeometry(0.83, 0.83, 0.07, 14), color: "#7c776c", position: [0, 0.52, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.8, 0.35, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.8, 0.35, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.8, 0.35, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.8, 0.35, 0.8] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.78, 0.82, 0.46, 14), color: "#9a958a", position: [0, 0.37, 0] },
      { geometry: new THREE.CylinderGeometry(0.83, 0.83, 0.07, 14), color: "#7c776c", position: [0, 0.58, 0] },
      { geometry: new THREE.CylinderGeometry(0.78, 0.78, 0.05, 14), color: "#6e4f2e", position: [0, 0.66, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.07, 0.26), color: "#5b4326", position: [0, 0.72, -0.05] },
      { geometry: new THREE.BoxGeometry(0.06, 0.04, 0.06), color: "#7c776c", position: [0.09, 0.77, 0.04] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.18, 8), color: "#4a4540", position: [0, 0.28, 0.86], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.1, 0.05), color: "#4a4540", position: [0, 0.32, 0.93] },
    ] },
  ],
  animations: [],
});
